export const validateUserName = (name) => !/[<>]/u.test(name);
//# sourceMappingURL=userName.js.map